/* eslint-disable no-shadow */
import createReducer from '../../helpers/createReducer';
import {
  recycleRight as state
} from '../store';

export default createReducer(state, {
  SET_DONE_MATERIAL: (state, { data: doneMaterials }) => ({
    ...state,
    doneMaterials: [...state.doneMaterials, doneMaterials]
  }),
  REMOVE_DONE_MATERIAL: (state, { data: numOfQuestions }) => ({
    ...state,
    doneMaterials: state.doneMaterials.splice(0, state.doneMaterials.length - numOfQuestions)
  }),
  SET_SWIPER_LEVEL: (state, { data: currentLevel }) => ({
    ...state,
    currentLevel
  })
});
